import { render, staticRenderFns } from "./LegalAgreementModal.vue?vue&type=template&id=5ae1be8a&scoped=true"
import script from "./LegalAgreementModal.vue?vue&type=script&lang=js"
export * from "./LegalAgreementModal.vue?vue&type=script&lang=js"
import style0 from "./LegalAgreementModal.vue?vue&type=style&index=0&id=5ae1be8a&prod&scoped=true&lang=css"
import style1 from "./LegalAgreementModal.vue?vue&type=style&index=1&id=5ae1be8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae1be8a",
  null
  
)

export default component.exports